module.exports = __webpack_public_path__ + "static/img/2.0ef4a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R22/2.jpg
// module id = CJRX
// module chunks = 1